import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LaunchDoctorPageRoutingModule } from './launch-doctor-routing.module';

import { LaunchDoctorPage } from './launch-doctor.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LaunchDoctorPageRoutingModule
  ],
  declarations: [LaunchDoctorPage]
})
export class LaunchDoctorPageModule {}
